@layer ui-kit;
@layer ui-kit {
  ._17kcnmn0 {
    width: 24px;
    height: 24px;
  }
  ._17kcnmn1 {
    width: 32px;
    height: 32px;
  }
  ._17kcnmn2 {
    width: 40px;
    height: 40px;
  }
  ._17kcnmn3 {
    width: 48px;
    height: 48px;
  }
  ._17kcnmn4 {
    width: 80px;
    height: 80px;
  }
  ._17kcnmn5 {
    width: 120px;
    height: 120px;
  }
  ._17kcnmn6 {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    overflow: hidden;
    user-select: none;
    padding: 3px;
    flex-shrink: 0;
    border-radius: 100%;
  }
  ._17kcnmn7 {
    object-fit: cover;
    height: 100%;
    width: 100%;
    border-radius: inherit;
  }
  ._17kcnmn8 {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--_1qu8za2f);
    color: var(--_1qu8za23);
    border-radius: inherit;
    padding: 22%;
  }
}